import { useId, type ComponentProps, type ReactNode } from "react";
import { cn } from "@/shared/utils/cn";
import { SectionHeader } from "./SectionHeader";

export interface SectionProps extends Omit<ComponentProps<"section">, "title"> {
  title: ReactNode;
  count?: ReactNode;
  action?: ReactNode;
  card?: boolean;
}

export function Section({ title, count, action, card = false, className, children, ...props }: SectionProps) {
  const headingId = useId();
  return (
    <section
      aria-labelledby={headingId}
      className={cn("min-w-0 space-y-3", card && "rounded-[20px] border border-border bg-card p-4 sm:p-5", className)}
      {...props}
    >
      <SectionHeader title={title} count={count} action={action} headingId={headingId} />
      {children}
    </section>
  );
}
